import { create } from "zustand";

const initialState = {
  steps: {},
  byProject: {},
  error: null,
};

export const useScenesMigrationStore = create((set, get) => ({
  ...initialState,
  getSteps: (projectId) => get().byProject[projectId]?.steps || [],
  setActive: (projectId, active) => set((state) => ({ byProject: { ...state.byProject, [projectId]: { ...state.byProject[projectId], isActive: active } } })),
  setModalOpen: (projectId, open) => set((state) => ({ byProject: { ...state.byProject, [projectId]: { ...state.byProject[projectId], modalOpen: open } } })),
  addStep: (projectId, step) => {
    set((state) => {
      const updatedState = {
        byProject: {
          ...state.byProject,
          [projectId]: {
            ...state.byProject[projectId],
            steps: [...(state.byProject[projectId]?.steps || []), step],
            isActive: true,
          },
        },
      };
      return updatedState;
    });
  },
  getIsActive: (projectId) => get().byProject[projectId]?.isActive,
}));
